/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getIssuedCard} from '../api'

 export const useQueryGetIssuedCard = createReactQueryHook('getIssuedCard', getIssuedCard)
